/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


